import routes from "@routes/routes";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative grid place-items-center h-screen">
      <div className="max-w-[500px] text-center">
        <h1 className="text-7xl font-medium text-lightBlue">{404}</h1>
        <h3 className="text-4xl block my-4 text-lightBlue">
          Whoops. Page lost...
        </h3>
        <p className="text-lightBlue text-base">
          Whoops, this is embarrassing. Looks like the page you were looking for
          wasn't found.
        </p>
        <button
          onClick={() => {
            navigate(routes.default);
          }}
          className="text-white w-full rounded-md bg-primary p-4 mt-10 my-5 ease-in duration-150 hover:scale-95"
          aria-label="Go back to home"
        >
          Go back to home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
